const UNIX_TIMESTAMP_MIN = 1e11;
const INDEX_EPSILON = 1e-6;
const VALUE_EPSILON = 1e-8;
function resolveAnchorTimestamp(point) {
    if (typeof point.timeMsHint === "number" && Number.isFinite(point.timeMsHint)) {
        return point.timeMsHint;
    }
    if (typeof point.x === "number" && Number.isFinite(point.x) && point.x >= UNIX_TIMESTAMP_MIN) {
        return point.x;
    }
    return null;
}
function reconcilePoint(point, timeIndexMap) {
    const timestamp = resolveAnchorTimestamp(point);
    let nextPoint = point;
    let changed = false;
    if (timestamp !== null && typeof point.y === "number" && Number.isFinite(point.y)) {
        if (typeof point.yPrice !== "number" || !Number.isFinite(point.yPrice) || Math.abs(point.yPrice - point.y) > VALUE_EPSILON) {
            nextPoint = {
                ...nextPoint,
                yPrice: point.y,
            };
            changed = true;
        }
    }
    if (timestamp === null) {
        return { point: nextPoint, changed };
    }
    const resolvedIndex = timeIndexMap.resolveIndexByTime(timestamp);
    if (resolvedIndex === null || !Number.isFinite(resolvedIndex)) {
        return { point: nextPoint, changed };
    }
    // R-04 future/past guard: ngoài biên dữ liệu thì xIndexFloat là SSOT —
    // không ghi đè từ timestamp (timestamp ngoài biên phụ thuộc bước ngoại suy,
    // đổi khi append bar qua kỳ nghỉ/cuối tuần). Chỉ suy lại timeMsHint.
    if (typeof point.xIndexFloat === "number" && Number.isFinite(point.xIndexFloat)) {
        const bounds = timeIndexMap.getTimeBounds?.() ?? null;
        const outRight = bounds !== null && timestamp > bounds.lastTime && point.xIndexFloat >= bounds.length - 1;
        const outLeft = bounds !== null && timestamp < bounds.firstTime && point.xIndexFloat < 0;
        if (outRight || outLeft) {
            const healed = timeIndexMap.resolveTimeByIndex(point.xIndexFloat);
            const nextTimeMsHint = typeof healed === "number" && Number.isFinite(healed) ? healed : timestamp;
            if (nextTimeMsHint === point.timeMsHint) {
                return { point: nextPoint, changed };
            }
            return { point: { ...nextPoint, timeMsHint: nextTimeMsHint }, changed: true };
        }
    }
    if (typeof point.xIndexFloat === "number" && Number.isFinite(point.xIndexFloat) && Math.abs(point.xIndexFloat - resolvedIndex) <= INDEX_EPSILON) {
        return { point: nextPoint, changed };
    }
    return {
        point: {
            ...nextPoint,
            xIndexFloat: resolvedIndex,
            ...(typeof point.timeMsHint === "number" && Number.isFinite(point.timeMsHint)
                ? { timeMsHint: point.timeMsHint }
                : { timeMsHint: timestamp }),
        },
        changed: true,
    };
}
export function reconcileForkDrawingIndexAnchors(drawings, timeIndexMap) {
    let changed = false;
    const nextDrawings = drawings.map((drawing) => {
        let drawingChanged = false;
        const nextPoints = drawing.points.map((point) => {
            const reconciled = reconcilePoint(point, timeIndexMap);
            if (reconciled.changed) {
                drawingChanged = true;
            }
            return reconciled.point;
        });
        if (!drawingChanged) {
            return drawing;
        }
        changed = true;
        return {
            ...drawing,
            points: nextPoints,
        };
    });
    return {
        drawings: changed ? nextDrawings : drawings,
        changed,
    };
}
